// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3fVmn","avatarImage":"_1WiUX","profileName":"hJEnd","reply":"_3D-Qs","postPage":"_2hKoC","user":"_1Xuck","profileInfo":"_8r7xP"};